import React from 'react'
import { Box, Container, Typography } from '@mui/material/'
import { RelateCatalogs } from '@components/RelateCatalogs'
import { StyledArticle } from '@components/organisms/Article/StyledArticle'
import NewsTabs from '@containers/Home/NewsTabs'
import { WordFragment } from '@services/graphcms/client'

type Props = {
  word: WordFragment
}

export const Word = (props: Props) => (
  <>
    <NewsTabs />
    <Container maxWidth="md">
      <Box minHeight="80vh" marginTop={2} marginBottom={2}>
        <Typography align="left" fontWeight="bold" variant="h5">
          {props.word.title}
        </Typography>
        <Typography color="textSecondary" component="span" variant="caption">
          {props.word.wordCategory?.name}
        </Typography>
        <div>
          <StyledArticle
            dangerouslySetInnerHTML={{
              __html: props.word.content.html,
            }}
          />
        </div>
        {(props.word.catalogFirstDepthCategoryId ||
          props.word.catalogSecondDepthCategoryId ||
          props.word.catalogThirdDepthCategoryId) && (
          <RelateCatalogs
            category={{
              catalogFirstDepthCategoryId: props.word.catalogFirstDepthCategoryId,
              catalogSecondDepthCategoryId: props.word.catalogSecondDepthCategoryId,
              catalogThirdDepthCategoryId: props.word.catalogThirdDepthCategoryId,
            }}
          />
        )}
      </Box>
    </Container>
  </>
)
